// extracted by mini-css-extract-plugin
module.exports = {"house":"house-3t_de87f"};